import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function AWSAccountKeyField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (!/^\w+$/.test(newValue)) {
      setError('Account Key can only contain letters and numbers.');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Account Key'
          id='key-id'
          aria-describedby='key-id-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={error}
          value={value}
        />
        {error ? (
          <FormHelperText id='key-id-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='key-id-helper-text'>
            Enter the proxiML IAM user AWS Account Key
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
